<template>
    <div class="header-background">
        <div class="header-content align-left">
            <h2>Build Better Products Faster</h2>
            <div class="overlap">Access FREE symbols, footprints and 3D models from the World's Largest Cad Library</div>
            <SearchContentPane :searchType="searchType" :setMfrId="currentSearchMfrId" :setText="currentSearchText" :manufacturerItems="manufacturerItems" @searchRequest="search"></SearchContentPane>
            <div class="overlap dark-link">
                Not sure where to start? Try a sample search like
                <router-link :to="`/${$store.state.instance}/search/keyword/src/TCK-048/p/1`">TCK-048</router-link> or
                <router-link :to="`/${$store.state.instance}/search/keyword/src/MAX17690ATE%2B/p/1`">MAX17690ATE+</router-link>
            </div>
        </div>
        <div class="body-content">
            <div class="d-flex flex-row flex-wrap justify-content-around align-center">
                <div class="flex-1">
                    <h3>Search</h3>
                    <span>Verified symbols, footprints, and 3D models</span>
                </div>
                <div class="flex-1">
                    <h3>Download</h3>
                    <span>Models available in over 24 CAD formats</span>
                </div>
                <div class="flex-1">
                    <h3>Design</h3>
                    <span>Focus on innovation, not part creation</span>
                </div>
            </div>
            <div class="align-center ul-red-panel">
                <h4>Built to the Hightest Standards</h4>
                <div class="font-small d-flex flex-row flex-wrap justify-content-around align-center">
                    <div class="flex-1 align-left spacer-div">
                        <h5>Utilizes Globally Recognized Industy Standards</h5>
                        <span class="small-span">We utilize globally recognized industry standards from IPC-73S1B for PCB footprints ANSI Y32.2-1975 (reaffirmed 1989) for schematic symbols, and ISO10313-21 for 3D STEP models.</span>
                    </div>
                    <div class="flex-1"></div>
                    <div class="flex-1 align-left spacer-div">
                        <h5>The Most Rigorous Part Verification in the Industry</h5>
                        <span class="small-span">Parts must pass over 30 different verification tests prior to be added to our library.</span>
                    </div>
                </div>
                <a class="btn btn-dark" target="_blank" href="https://www.ultralibrarian.com/about/standards?utm_source=designspark&utm_medium=partner&utm_campaign=home">Learn About Our Verification Process</a>
            </div>
            <div class="align-center">
                <h4 class="mt-5">The Broadest CAD Tool Support in the Industry</h4>
                <div class="font-smaller">
                    <span>Get the symbols, footprints, and 3D models you need for your CAD tool.</span>
                </div>
                <div class="font-smaller dark-link">
                    <a target="_blank" href="https://www.ultralibrarian.com/about/standards?utm_source=designspark&utm_medium=partner&utm_campaign=home">Full List of Compatible CAD Tools</a>
                </div>
            </div>
            <p style="text-align:center">
                <img alt="Altium Logo" title="Infineon Logo" class="media-element file-default" src="@/assets/images/logo/Altium_Home_1.png">
                <img alt="Cadence Labs Logo" title="Silicon Labs Logo" class="media-element file-default" src="@/assets/images/logo/Cadence_Home_0.png">
                <img alt="Eagle Logo" title="Cree Wolfspeed Logo" class="media-element file-default" src="@/assets/images/logo/Eagle_Home_0.png">
                <img alt="Fusion360 Logo" title="Kemet Logo" class="media-element file-default" src="@/assets/images/logo/fusion360.png">
                <img alt="KiCad Logo" title="Active-Semi Logo" class="media-element file-default" src="@/assets/images/logo/KiCAD_Home_0.png">
                <img alt="Mentor Graphics Logo" title="Maxim Logo" class="media-element file-default" src="@/assets/images/logo/Mentor_Graphics_Logo.svg.png">
                <img alt="OrCAD Logo" title="TE logo" class="media-element file-default" src="@/assets/images/logo/OrCAD_Home_0.png">
                <img alt="PADS Logo" title="STMicroelectronics logo" class="media-element file-default" src="@/assets/images/logo/PADS_NO_MG__NOtag_PMS2995-520x225.png">
                <img alt="Proteus Logo" title="Trinamic Logo" class="media-element file-default" src="@/assets/images/logo/Proteus_Home.png">
                <img alt="Quadcept Logo" title="Texas Instruments Logo" class="media-element file-default" src="@/assets/images/logo/Quadcept_Home_0.png">
                <img alt="Zuken Logo" title="Toshiba Logo" class="media-element file-default" src="@/assets/images/logo/Zuken_Home.png">
            </p>
            <div class="d-flex flex-row flex-wrap justify-content-around align-center lower-panel">
                <router-link class="btn btn-primary flex-1" :to="`/${$store.state.instance}/search/`">Start Searching Now</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import SearchContentPane from '@/components/search/search-content-pane.vue'

    export default {
        name: 'StartPanelFusion360',

        components: {
            SearchContentPane
        },
        data() {
            return {
                currentPart: null,
                currentSearchMfrId: null,
                currentSearchText: null
            }
        },
        computed: {
            ...mapState({
                instance: state => state.instance
            })
        },
        methods: {
            search: async function (manufacturerId, searchText) {
                this.$router.isReady();
                var mfrId = "";
                var searchTerm = "";
                if (typeof (manufacturerId) != undefined && manufacturerId && manufacturerId != null) {
                    mfrId = manufacturerId;
                }
                if (typeof (searchText) != undefined && searchText && searchText != null) {
                    searchTerm = searchText;
                }
                this.$store.commit('SEARCH_START');
                this.$store.commit('SET_SEARCH_VALUES', { searchType: 'external', searchManufacturerId: mfrId, searchText: searchTerm, page: 1 });
            }
        },
        props: {
            searchType: {
                type: String,
                default: () => {
                    return "external"
                }
            },
            manufacturerItems: {
                type: Array,
                default: () => {
                    return [];
                }
            }
        }
    };
</script>

<style scoped>

    .media-element {
        width: 150px;
    }

    .header-background div {
        padding-bottom: 1em;
    }

    div.font-small {
        font-size: 1.25em;
    }

    div.font-smaller {
        font-size: .75em;
    }

    .search-div button {
        width: 100px;
    }

    .dark-link a {
        color: black;
        text-decoration: underline;
    }

    form {
        width: 600px;
        margin: auto;
    }

    h2, h3, h4, h5 {
        font-weight: bold;
        padding: 1.5em 0em .75em 0em;
    }

    h2 {
        padding-bottom: 0px;
    }

    h3 {
        color: var(--ul-red);
        padding-top: 3em;
    }

    h5 {
        font-size: 1rem;
    }

    .small-span {
        display: inline-block;
        font-size: .8em;
    }

    @media (min-width: 1300px) {
        .header-background {
            background: transparent url('~@/assets/images/start/start_banner.jpg') no-repeat right top;
            background-size: 1070px;
        }

        .header-content {
            width: 800px;
            margin: auto;
            padding-right: 260px;
            text-align: center;
        }

        .header-content h2 {
            padding-top: 100px;
        }

        div.overlap {
            width: 650px;
        }

        .body-content {
            width: 800px;
            margin: auto;
        }

        .search-div input {
            float: left;
            width: 500px;
            margin-top: 22px;
        }

        div.ul-red-panel {
            padding: 0em 2em 2em 2em;
            margin-top: 3.5em;
            border-width: .25em;
        }

        div.lower-panel a.btn {
            margin: 0em 100px;
        }

        .align-center {
            text-align: center;
            flex-wrap: nowrap;
            flex-grow: 1;
        }

        .align-left {
            text-align: left;
            flex-wrap: nowrap;
            flex-grow: 1;
        }

        .flex-1 {
            flex: 1 1 0px;
        }
    }

    @media (max-width: 1299.9px) {

        body {
            font-size: 80%;
        }

        h2, h3, h4, h5 {
            font-weight: bold;
            padding: .5em 0em .25em 0em;
        }

        .header-content {
            text-align: center;
        }

        .search-div input {
            float: left;
            width: 350px;
            margin-top: 2em;
        }

        div.lower-panel a.btn {
            margin: 10px 25px;
        }

        div.ul-red-panel {
            padding: 0em .5em .5em .5em;
            margin-top: 0em;
            border-width: .25em;
        }

        .align-center {
            text-align: center;
        }

        .align-left {
            text-align: center;
        }

        .flex-1 {
            flex-wrap: wrap;
            width: 400px;
        }

        form {
            width: 450px;
        }
    }
</style>